import axios from 'axios';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import ArrowNextMobile from '../shared/ArrowNextMobile';
import ArrrowPrevMobile from '../shared/ArrrowPrevMobile';
import useStore from '../../store/store';
import { useDateChoiceData } from '../../hooks/useDateChoiceData';
import CalendarMonthSlide from '../shared/CalendarMonthSlide';
import CalendarLegend from '../shared/CalendarLegend';
import { isMobile } from 'react-device-detect';
import '../../App.scss';
import NavigationMobile from '../mobile/NavigationMobile';

const DateChoiceMobile = () => {
  const { setArrivalDate, arrivalDate, rooms, step } = useStore();
  const { dates, allowedLengths, discounts } = useDateChoiceData(rooms);

  const handleClickOnDate = (item) => {
    setArrivalDate(item.date);
  };

  return (
    <>
      <div className='MobileMain__wrapper'>
        <div className='MobileMain__step roboto-regular'>Шаг {step}/5</div>
        <h2>Выберите дату заезда*</h2>
        <Swiper
          className='DateChoiceMobile__swiper'
          modules={[Navigation]}
          slidesPerView={isMobile ? 1 : 3}
          spaceBetween={0}
        >
          <ArrrowPrevMobile />
          {Object.entries(dates).map(([key, items]) => {
            const [year, month] = key.split('-');
            return (
              <SwiperSlide key={key}>
                <CalendarMonthSlide
                  year={year}
                  month={month}
                  items={items}
                  allowedLengths={allowedLengths}
                  arrivalDate={arrivalDate}
                  discounts={discounts}
                  onDateClick={handleClickOnDate}
                />
              </SwiperSlide>
            );
          })}
          <ArrowNextMobile />
        </Swiper>

        <CalendarLegend />
        {isMobile && <NavigationMobile isBtnDisabled={arrivalDate === null} />}
      </div>
    </>
  );
};

export default DateChoiceMobile;
